import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { throttle } from 'lodash';
import { getEventTrackerContext } from 'state/selectors';
import { buildEvent, buildRequestHeaders } from './helpers';
const EVENT_SYNC_RATE = 1000;
export const FAILURES_TO_DISABLE = 3;

class EventTracker {
  // Used when requested events could not be built (due to unavailable context, for example)
  constructor(_ref) {
    let {
      relay,
      store,
      contextSelector
    } = _ref;

    _defineProperty(this, "eventStore", void 0);

    _defineProperty(this, "relay", void 0);

    _defineProperty(this, "context", null);

    _defineProperty(this, "reduxStore", null);

    _defineProperty(this, "errorState", {
      consecutiveFailures: 0,
      isDisabled: false
    });

    _defineProperty(this, "contextSelector", null);

    _defineProperty(this, "eventQueue", []);

    _defineProperty(this, "syncThrottled", throttle(this.sync, EVENT_SYNC_RATE));

    _defineProperty(this, "handleReduxStoreChange", () => {
      if (!this.reduxStore || !this.contextSelector) return;
      this.updateContext(this.contextSelector(this.reduxStore.getState()));
      this.drainEventQueue();
    });

    _defineProperty(this, "track", event => {
      if (this.errorState.isDisabled) return; // Context may not be available yet, therefore we need to queue the event for it to be built and
      // sent at a later time.

      if (!this.context) {
        this.eventQueue.push(event);
        return;
      }

      const preparedEvent = buildEvent(event, this.context);
      this.eventStore.add(preparedEvent);
      this.syncThrottled();
    });

    this.eventStore = store;
    this.relay = relay;
    this.contextSelector = contextSelector || getEventTrackerContext;
  }

  initialize(store) {
    this.reduxStore = store;
    this.handleReduxStoreChange();
    store.subscribe(this.handleReduxStoreChange);
  }

  drainEventQueue() {
    if (!this.eventQueue.length) return;
    this.eventQueue.forEach(event => this.track(event));
    this.eventQueue = [];
  }

  updateContext(context) {
    this.context = context;
  }

  sync() {
    if (!this.context) return;
    const events = this.eventStore.events.pending;
    const headers = buildRequestHeaders(this.context);

    const success = () => {
      this.errorState.consecutiveFailures = 0;
      this.eventStore.clear('outgoing');
    };

    const failure = () => {
      this.errorState.consecutiveFailures += 1;

      if (this.errorState.consecutiveFailures >= FAILURES_TO_DISABLE) {
        this.errorState.isDisabled = true;
        this.eventQueue = [];
        this.eventStore.clear('outgoing');
        this.eventStore.clear('pending');
        return;
      } // Add outgoing events back to pending queue


      events.forEach(event => this.eventStore.add(event));
      this.eventStore.clear('outgoing');
    };

    this.eventStore.movePending();
    this.relay.transport({
      payload: events,
      headers,
      success,
      failure
    });
  }

}

export default EventTracker;